define((require) => {
    "use strict";

    var Backbone = require("backbone");

    /**
     * A virtual Backbone collection containing all of the models of a backing collection that meet a filter test.
     *
     * <p>This collection is only suitable for use as a view of the underlying models/collections. Avoid calling
     * functions that manipulate the collection, as this has undefined behaviour.</p>
     *
     * <p>When changes are made to the backing collection, a reset is fired from this collection.</p>
     *
     * @author Bruce Mackenzie Nielsen
     * @class FilteredCollection
     *
     * @param {Collection} collection The backing collection to filter.
     * @param {Function} filter The filter function. Should return true for models that pass the filter.
     */
    return Backbone.Collection.extend({

        _backingCollection: null,
        _filterFunction: null,

        _getModelArray: function() {
            return this._backingCollection.filter(this._filterFunction);
        },

        constructor: function(collection, filter) {
            this._backingCollection = collection;
            this._filterFunction = filter;

            // Initialize the virtual collection
            Backbone.Collection.call(this, this._getModelArray());

            // Register event handlers
            this.listenTo(collection, "change add remove reset sort", function() {
                this.reset(this._getModelArray());
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/zbone/FilteredCollection.js